export default __webpack_public_path__ + "static/media/bedroom2.b0604ebb.jpg";